import Page404 from "pages/PageError/Page404";

export const otherPages = [
  {
    path: "/404",
    exact: true,
    name: "Trang không tồn tại",
    component: Page404,
  },
];
